import { api } from './client'

export interface PlatformTenant {
  id: number
  name: string
  environment: string | null
  organization: string | null
}

export const platformApi = {
  /** Lista TODOS os tenants da plataforma (escopo global — gated no backend). */
  listAllTenants: () =>
    api.get<PlatformTenant[]>('/v1/platform/tenants').then((r) => r.data),
}
